import React from "react";
import SortOrderIndicators from "../SortOrderIndicators";

export default function AdditionalColumnTHs(props) {
  if (!props.columns?.length > 0) {
    return null;
  }

  return props.columns.map((additionalColumn) => {
    return (
      <th
        key={additionalColumn.id}
        className="c-parts-listing__table-header"
        onClick={() => props.changeSortProperty(additionalColumn)}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex">
          <span
            style={{
              textDecoration: props.sortProperty === additionalColumn.id ? "underline" : "none",
            }}
          >
            {additionalColumn.text}
          </span>

          <SortOrderIndicators
            sortType={props.sortType}
            sortProperty={props.sortProperty}
            currentProperty={additionalColumn.id}
          />
        </div>
      </th>
    );
  });
}
